var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    { attrs: { width: "500", height: "100" } },
    [
      _c("vector", { attrs: { width: 10, height: 10 } }, [
        _c("rect", { attrs: { width: "100", height: "50", fill: "red" } })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }